export default "__VITE_ASSET__CjwAWDrF__"